import Grid from "@components/Grid/Grid";
import { useRef } from "react";
import accordionStyles from "../C11_VerticalAccordion/C11_VerticalAccordion.module.scss";
import ProgrammeBlock, { Fields } from "./C25_ProgrammeBlock";
import { useRowEqualHeights } from "./useRowEqualHeights";

import clsx from "clsx";
import styles from "./C25_NavigationManual.module.scss";

export interface ProgrammeBlockData {
  metadata: { tags: string[] };
  fields: Fields;
}

export interface NavigationManualProps {
  programmeBlocks: ProgrammeBlockData[];
  cssClass: "blue" | undefined;
  bulletColor: "white" | undefined;
}

export const NavigationManual = (props: { content: NavigationManualProps }) => {
  const { content } = props;
  const { programmeBlocks, cssClass, bulletColor } = content;
  const fullWidth = programmeBlocks.length === 1;
  const rootRef = useRef<HTMLDivElement | null>(null);

  useRowEqualHeights(
    rootRef,
    styles["programme-info"],
    false,
    accordionStyles["accordion-drop"]
  );

  return (
    <div
      ref={rootRef}
      className={clsx(
        "navigation-manual",
        styles["navigation-manual"],
        styles[cssClass],
        styles[bulletColor],
        fullWidth && styles["full-width"]
      )}
    >
      <div className="wrapper">
          <Grid row>
            {programmeBlocks.map((programmeBlock, index) => (
              <Grid
                key={`${programmeBlock.fields?.title}${index}`}
                column
                sm={12}
                md={
                  programmeBlocks.length <= 4 ? 12 / programmeBlocks.length : 4
                }
              >
                <ProgrammeBlock
                  fullWidth={fullWidth}
                  {...programmeBlock.fields}
                  isBlue={cssClass === "blue"}
                />
              </Grid>
            ))}
          </Grid>
      </div>
    </div>
  );
};

export default NavigationManual;
